var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:["kv_item_cla", ("label_text_" + _vm.type)]},[_c('label',[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),_c('span',{staticClass:"value-cla"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c87056c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/kvLine/src/main.vue
// module id = null
// module chunks = 